<template>
  <div>
    <Button type="primary" @click="modal1 = true">新增</Button>
    <Button type="primary" @click="selmachine" style="margin-left: 10px;">刷新</Button>
    <Select
          v-model="machineType"
          placeholder="选择机器类型"
          style="width: 200px; margin-top: 10px"
          @on-change="handleCurrencyTypeChange"
        >
          <Option value="">全部</Option>
          <Option value="1">三爪机</Option>
          <Option value="2">二爪机</Option>
      </Select>
    <Table :columns="columns10" :data="data9"> </Table>

    <Modal
      v-model="modal1"
      title="新增机器"
      width="1000"
      :loading="loading"
      :mask-closable="false"
      @on-ok="ok"
      @on-cancel="cancel"
    >
      <div>
        <Form :label-width="120">
          <FormItem label="机器类型">
            <RadioGroup v-model="jiqitype">
              <Radio label="1">三爪机</Radio>
              <Radio label="2" checked>二爪机</Radio>
            </RadioGroup>
          </FormItem>
          <FormItem label="方向">
            <RadioGroup v-model="direction">
              <Radio :label="0">右</Radio>
              <Radio :label="1">左</Radio>
            </RadioGroup>
          </FormItem>
          <FormItem label="小板号">
            <Input placeholder="请输入小板号" v-model="jiqihao"></Input>
          </FormItem>
          <FormItem label="房间名称">
            <Input placeholder="请输入房间名称" v-model="roomname"></Input>
          </FormItem>
          <FormItem label="备注名称">
            <Input placeholder="请输入备注名称" v-model="broomname"></Input>
          </FormItem>
          <FormItem label="房间副标题">
            <Input placeholder="请输入房间副标题" v-model="froomname"></Input>
          </FormItem>
          <FormItem label="房间等级">
            <Input placeholder="请输入房间等级" v-model="roomlv"></Input>
          </FormItem>
          <FormItem label="单价">
            <Input placeholder="请输入单价" v-model="danjia"></Input>
          </FormItem>
          <FormItem label="视频地址">
            <Input placeholder="请输入视频地址" v-model="videourl1"></Input>
          </FormItem>
          <FormItem label="视频地址(副)">
            <Input placeholder="请输入视频地址" v-model="videourl2"></Input>
          </FormItem>
          <FormItem label="输入礼品id">
            <Input placeholder="请输奖励" v-model="jiangli"></Input>
            <Button type="primary" size="small" @click="openGoodsSearchModal" style="margin-left: 5px;">查询商品</Button>
          </FormItem>
          <FormItem label="询奖时间">
            <Input placeholder="请输询奖时间" v-model="wawatime"></Input>
          </FormItem>
          <FormItem label="中奖是否发维护信息">
            <RadioGroup v-model="wintishi">
              <Radio label="是">是</Radio>
              <Radio label="否" checked>否</Radio>
            </RadioGroup>
          </FormItem>
          <FormItem label="排序">
            <Input placeholder="请输入排序" v-model="sort" @input="validateNumber('sort')"></Input>
          </FormItem>
          <FormItem label="中奖是否抽勋章">
            <RadioGroup v-model="ismedal">
              <Radio label="是">是</Radio>
              <Radio label="否" checked>否</Radio>
            </RadioGroup>
          </FormItem>

          <single-upload title="上传封面图" :old-url="fengmian" @update:image="updateimage1" />
          <single-upload title="上传规则图"   @update:image="updateimage2" />
        </Form>
      </div>
    </Modal>
    <Modal
      v-model="editModal"
      title="编辑机器"
      width="1000"
      :loading="loading"
      @on-ok="editOk"
      @on-cancel="editCancel"
    >
      <div>
        <Form :label-width="120">
          <FormItem label="机器类型">
            <RadioGroup v-model="editForm.jiqitype">
              <Radio label="1">三爪机</Radio>
              <Radio label="2" checked>二爪机</Radio>
            </RadioGroup>
          </FormItem>
          <FormItem label="方向">
            <RadioGroup v-model="editForm.direction">
              <Radio :label="0">右</Radio>
              <Radio :label="1">左</Radio>
            </RadioGroup>
          </FormItem>
          <FormItem label="小板号">
            <Input placeholder="请输入小板号" v-model="editForm.jiqihao"></Input>
          </FormItem>
          <FormItem label="房间名称">
            <Input placeholder="请输入房间名称" v-model="editForm.roomname"></Input>
          </FormItem>
          <FormItem label="备注名称">
            <Input placeholder="请输入备注名称" v-model="editForm.broomname"></Input>
          </FormItem>
          <FormItem label="房间副标题">
            <Input placeholder="请输入房间副标题" v-model="editForm.froomname"></Input>
          </FormItem>
          <FormItem label="房间等级">
            <Input placeholder="请输入房间等级" v-model="editForm.roomlv"></Input>
          </FormItem>
          <FormItem label="单价">
            <Input placeholder="请输入单价" v-model="editForm.danjia"></Input>
          </FormItem>
          <FormItem label="视频地址">
            <Input placeholder="请输入视频地址" v-model="editForm.videourl1"></Input>
          </FormItem>
          <FormItem label="视频地址(副)">
            <Input placeholder="请输入视频地址" v-model="editForm.videourl2"></Input>
          </FormItem>
          <FormItem label="输入礼品id">
            <Input placeholder="请输奖励" v-model="editForm.jiangli"></Input>
            <Button type="primary" size="small" @click="openGoodsSearchModal" style="margin-left: 5px;">查询商品</Button>
          </FormItem>
          <FormItem label="询奖时间">
            <Input placeholder="请输询奖时间" v-model="editForm.wawatime"></Input>
          </FormItem>
          <FormItem label="中奖是否发维护信息">
            <RadioGroup v-model="editForm.wintishi">
              <Radio label="是">是</Radio>
              <Radio label="否" checked>否</Radio>
            </RadioGroup>
          </FormItem>
          <FormItem label="排序">
            <Input placeholder="请输入排序" v-model="editForm.sort" @input="validateEditNumber('sort')"></Input>
          </FormItem>
          <FormItem label="中奖是否抽勋章">
            <RadioGroup v-model="editForm.ismedal">
              <Radio label="是">是</Radio>
              <Radio label="否" checked>否</Radio>
            </RadioGroup>
          </FormItem>

          <single-upload title="上传封面图" :old-url="editForm.fengmian" @update:image="updateEditimage1" />
          <single-upload title="上传规则图" :old-url="editForm.guize" @update:image="updateEditimage2" />
        </Form>
      </div>
    </Modal>
    <wawaGameListModal
      :visible="modal3"
      :user_id="clickmachineid"
      @guanbimodal="guanbimodal"
    />
    <GoodsSearchModal
      :visible.sync="goodsSearchModal"
      :goodstypeOptions="goodstypeOptions"
      @select-goods="selectGoods"
    />
  </div>
</template>

<script>
import SingleUpload from "@/components/Upload/singleUpload";
import {
  setWawamachine,
  selWawaMachine,
  updateMachineStatus,
  updateWawaMachine,
} from "../../api/machine";
import { cmsSelgoods } from "../../api/product"; // 导入商品查询API
import wawaGameListModal from "./wawaGameListModal.vue";
import GoodsSearchModal from "@/components/GoodsSearchModal.vue";
import { formatOssUrl } from "@/utils";

const OSS = require("ali-oss");
var ossClient = null;
export default {
  components: { SingleUpload, wawaGameListModal, GoodsSearchModal },
  data() {
    return {
      goodstypeOptions: this.$goodsTypeOptions, // 商品分类选项
      machineType: "",
      modal3: false,
      jiqitype: "1",
      direction: 0, // 方向，0为右，1为左
      fengmian: "", //封面图
      guize: "", //规则图
      roomlv: "", //房间等级
      jiqihao: "", //机器号
      duankouhao: "", //端口号
      roomname: "", //房间名称
      broomname: "", //备注名称
      froomname: "", //副标题
      danjia: "", //单价
      jiangli: "", //奖励
      wawatime: "10", //询奖时间
      wintishi: "否", //中奖是否发维护信息
      ismedal: "否", //中奖是否抽勋章
      sort: "0", // 排序
      loading: true,
      modal1: false,
      submitting: false, // 提交状态
      xbid: "", //小板id
      clickmachineid: "",
      videourl1: "",
      videourl2: "",
      // 编辑相关数据
      editModal: false,
      editForm: {
        roomid: "", // 房间ID，用于更新时的标识
        jiqitype: "1",
        direction: 0, // 方向，0为右，1为左
        fengmian: "", //封面图
        guize: "", //规则图
        roomlv: "", //房间等级
        jiqihao: "", //机器号
        roomname: "", //房间名称
        broomname: "", //备注名称
        froomname: "", //副标题
        danjia: "", //单价
        jiangli: "", //奖励
        wawatime: "10", //询奖时间
        wintishi: "否", //中奖是否发维护信息
        ismedal: "否", //中奖是否抽勋章
        sort: "0", // 排序
        videourl1: "",
        videourl2: "",
      },
      columns10: [
        {
          title: "房间id",
          key: "roomid",
        },
        {
          title: "房间名称",
          key: "roomname",
        },
        {
          title: "备注名称",
          key: "broomname",
        },
        {
          title: "副标题",
          key: "froomname",
        },
        {
          title: "机器类型",
          key: "machinetype",
          render: (h, params) => {
            const status = params.row.machinetype;
            return h("span", status === 1 ? "三爪机" : "二爪机");
          },
        },
        {
          title: "房间等级",
          key: "roomlv",
        },

        {
          title: "单价",
          key: "price",
        },
        {
          title: "封面图",

          key: "image",
          render: (h, params) => {
            return h("img", {
              attrs: {
                src:formatOssUrl(params.row.roomimg) ,
              },
              style: {
                width: "50px",
                height: "50px",
                marginTop: "5px",
              },
            });
          },

          // key: "image",
        },
        {
          title: "奖品名称",
          key: "goodsname",
        },
        {
          title: "奖品id",
          key: "reward",
        },
        {
          title: "机器状态",
          key: "status",
          render: (h, params) => {
            const status = params.row.status;
            return h(
              "span",
              status === 0 ? "关机" : status === 1 ? "开机" : "维护"
            );
          },
        },
        {
          title: "操作",
          key: "action",
          width: 200,
          align: "center",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small",
                  },
                  style: {
                    marginRight: "5px",
                  },
                  on: {
                    click: () => {
                      this.editModal = true;
                      this.editForm.roomid = params.row.roomid;
                      this.editForm.jiqitype = params.row.machinetype === 1 ? "1" : "2";
                      this.editForm.direction = params.row.direction || 0;
                      this.editForm.jiqihao = params.row.machineid;
                      this.editForm.roomname = params.row.roomname;
                      this.editForm.broomname = params.row.broomname || "";
                      this.editForm.froomname = params.row.froomname || "";
                      this.editForm.roomlv = params.row.roomlv;
                      this.editForm.danjia = params.row.price;
                      this.editForm.jiangli = params.row.reward;
                      this.editForm.wawatime = params.row.wawatime;
                      this.editForm.wintishi = params.row.wintishi === 1 ? "是" : "否";
                      this.editForm.ismedal = params.row.ismedal === 1 ? "是" : "否";
                      this.editForm.videourl1 = params.row.videourl1;
                      this.editForm.videourl2 = params.row.videourl2;
                      this.editForm.fengmian = params.row.roomimg; // 设置封面图
                      this.editForm.guize = params.row.rule; // 设置规则图
                      this.editForm.sort = params.row.sort;
                    },
                  },
                },
                "编辑"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small",
                  },
                  style: {
                    marginRight: "5px",
                  },
                  on: {
                    click: () => {
                      this.clickmachineid = params.row.roomid.toString();
                      console.log("====" + this.clickmachineid);
                      this.modal3 = true;
                    },
                  },
                },
                "游戏记录"
              ),
              params.row.status === 0 || params.row.status === 2
                ? h(
                    "Button",
                    {
                      props: {
                        type: "primary",
                        size: "small",
                      },
                      style: {
                        marginRight: "5px",
                      },
                      on: {
                        click: () => {
                          this.clickmachineid = params.row.roomid;
                          this.updateMachineStatus(1);
                        },
                      },
                    },
                    "开机"
                  )
                : null,
              params.row.status === 1 || params.row.status === 2
                ? h(
                    "Button",
                    {
                      props: {
                        type: "primary",
                        size: "small",
                      },
                      style: {
                        marginRight: "5px",
                      },
                      on: {
                        click: () => {
                          this.clickmachineid = params.row.roomid;
                          this.updateMachineStatus(0);
                        },
                      },
                    },
                    "关机"
                  )
                : null,
              //娃娃机暂时去掉维护
              // params.row.status === 1
              //   ? h(
              //       "Button",
              //       {
              //         props: {
              //           type: "primary",
              //           size: "small",
              //         },
              //         style: {
              //           marginRight: "5px",
              //         },
              //         on: {
              //           click: () => {
              //             this.clickmachineid = params.row.roomid;
              //             this.updateMachineStatus(2);
              //           },
              //         },
              //       },
              //       "维护"
              //     )
              //   : null,
            ]);
          },
        },
      ],
      data9: [],
      // 商品查询相关数据
      goodsSearchModal: false,
      goodsSearchName: "",
      goodsSearchType: "",
      goodsData: [],
      goodsTotal: 0,
      goodsCurrent: 1,
      goodsColumns: [
        {
          title: "商品id",
          key: "id",
        },
        {
          title: "商品名称",
          key: "goodsname",
        },
        {
          title: "封面图片",
          key: "image",
          render: (h, params) => {
            return h("img", {
              attrs: {
                src:  formatOssUrl(params.row.goodsimg) ,
              },
              style: {
                width: "50px",
                height: "50px",
                marginTop: "5px",
              },
            });
          },
        },
        {
          title: "商品分类",
          key: "goodstype",
        },
        {
          title: "商品数量",
          key: "goodsnum",
        }, {
          title: "分解币数",
          key: "coinnum",
        },
        {
          title: "操作",
          key: "action",
          width: 150,
          align: "center",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small",
                  },
                  on: {
                    click: () => {
                      this.selectGoods(params.row);
                    },
                  },
                },
                "选择"
              ),
            ]);
          },
        },
      ],
    };
  },
  mounted() {
    this.selmachine();
  },
  methods: {
    selmachine() {
      console.log("===");

      selWawaMachine({
        machinetype: this.machineType
      }).then((res) => {
        console.log("===" + JSON.stringify(res));

        this.data9 = res.data;
      });
    },
    
    handleCurrencyTypeChange() {
      this.selmachine();
    },
    updateimage1(value) {
      this.fengmian = value;
      console.log("updateimage1" + value);
    },
    updateimage2(value) {
      this.guize = value;
      console.log("updateimage2" + value);
    },
    updateEditimage1(value) {
      this.editForm.fengmian = value;
      console.log("updateEditimage1" + value);
    },
    updateEditimage2(value) {
      this.editForm.guize = value;
      console.log("updateEditimage2" + value);
    },
    ok() {
      this.submitting = true;
      this.loading = true;
      setWawamachine({
        machineid: this.jiqihao,
        roomname: this.roomname,
        broomname: this.broomname,
        froomname: this.froomname || "",
        direction: this.direction,
        roomlv: this.roomlv,
        image: this.fengmian,
        rule: this.guize,
        price: this.danjia,
        reward: this.jiangli,
        wintishi: this.wintishi === "是" ? 1 : 0,
        ismedal: this.ismedal === "是" ? 1 : 0,
        wawatime: parseInt(this.wawatime),
        videourl1: this.videourl1,
        videourl2: this.videourl2,
        machinetype: this.jiqitype === "1" ? 1 : 2,
        sort: parseInt(this.sort) || 0,
      })
        .then((res) => {
          this.$Message.success("添加成功");
          this.modal1 = false;
          this.selmachine(); // 刷新列表
        })
        .catch((err) => {
          this.$Message.error("添加失败");
        })
        .finally(() => {
          this.submitting = false;
          this.loading = false;
        });
    },
    cancel() {
      this.$Message.info("Clicked cancel");
    },
    updateMachineStatus(status) {
      updateMachineStatus({ status: status, roomid: this.clickmachineid }).then(
        (res) => {
          this.selmachine();
        }
      );
    },
    guanbimodal() {
      this.modal3 = false;
    },
    editOk() {
      updateWawaMachine({
        roomid: this.editForm.roomid,
        machineid: this.editForm.jiqihao,
        roomname: this.editForm.roomname,
        broomname: this.editForm.broomname,
        froomname: this.editForm.froomname || "",
        direction: this.editForm.direction,
        roomlv: this.editForm.roomlv,
        image: this.editForm.fengmian,
        rule: this.editForm.guize,
        price: this.editForm.danjia,
        reward: this.editForm.jiangli,
        wintishi: this.editForm.wintishi === "是" ? 1 : 0,
        ismedal: this.editForm.ismedal === "是" ? 1 : 0,
        wawatime: parseInt(this.editForm.wawatime),
        videourl1: this.editForm.videourl1,
        videourl2: this.editForm.videourl2,
        machinetype: this.editForm.jiqitype === "1" ? 1 : 2,
        sort: parseInt(this.editForm.sort),
      })
        .then((res) => {
          this.editModal = false;
          this.$Message.info("Clicked ok");
          this.selmachine();
        })
        .catch((err) => {});
    },
    editCancel() {
      this.$Message.info("Clicked cancel");
    },
    // 打开商品查询弹窗
    openGoodsSearchModal() {
      this.goodsSearchModal = true;
      this.goodsSearchName = "";
      this.goodsSearchType = "";
      this.goodsCurrent = 1;
      this.searchProducts();
    },
    // 关闭商品查询弹窗
    closeGoodsSearchModal() {
      this.goodsSearchModal = false;
    },
    // 查询商品列表
    searchProducts() {
      const params = {
        goodsname: this.goodsSearchName || undefined,
        goodstype: this.goodsSearchType || undefined,
        page: this.goodsCurrent,
      };
      
      cmsSelgoods(params)
        .then((response) => {
          this.goodsData = response.data.rows;
          this.goodsTotal = response.data.pagination.total;
          this.goodsCurrent = response.data.pagination.page;
        })
        .catch((error) => {
          this.$Message.error("获取商品列表失败");
          console.error(error);
        });
    },
    // 商品列表分页
    changeGoodsPage(page) {
      this.goodsCurrent = page;
      this.searchProducts();
    },
    // 选择商品
    selectGoods(goods) {
      console.log("----"+JSON.stringify(goods));
      // 选择商品后关闭弹窗并设置礼品ID
      if (this.editModal) {
        // 如果是编辑模式
        this.editForm.jiangli = goods.id;
        this.editForm.fengmian = goods.goodsimg;
      } else {
        // 如果是新增模式
        this.jiangli = goods.id;
        this.fengmian = goods.goodsimg;
      }
      this.closeGoodsSearchModal();
      this.$Message.success("已选择商品：" + goods.goodsname);
    },
    // 验证数字输入
    validateNumber(field) {
      // 确保只能输入数字
      if (this[field] && !/^\d*$/.test(this[field])) {
        this[field] = this[field].replace(/[^\d]/g, '');
      }
    },
    // 验证编辑表单的数字输入
    validateEditNumber(field) {
      // 确保只能输入数字
      if (this.editForm[field] && !/^\d*$/.test(this.editForm[field])) {
        this.editForm[field] = this.editForm[field].replace(/[^\d]/g, '');
      }
    },
  },
};
</script>
